<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Organogram"
                   :links="[{title:'Home', url:'/'},{title:'Organogram'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="1"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1 text-center">Organogram of Institute</div>
          <div class="flex justify-center">
            <Image src="/static/images/governance/Organogram.jpg" alt="Image"
                   preview/>
          </div>
        </section>
      </div>
      <programmes></programmes>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/about/governance/Sidebar.vue";
import Programmes from "@/views/about/Programmes";
import Image from 'primevue/image';

export default {
  name: "About",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    Programmes, Image
  },
}
</script>
<style lang="scss" scoped/>

